import { tenantRequest } from './api/auth';
import { publicRequest } from './api/auth';

// 以流程設定租戶（精靈）的所有呼叫都不套 tenantRequest 預設的 30 秒逾時：
// 建立租戶要跑完所有 migration，Chatwoot 與 Azure Search 的呼叫也常超過 30 秒
const NO_TIMEOUT = { timeout: 0 };

class TenantCenterService {
    forgetPassword(data) {
        return publicRequest.post(`/tenant_center/account/passwordreset/`, data);
    }
    confirmPassword(data) {
        let obj = { 'token': data.token, 'password': data.password };
        return publicRequest.post(`/tenant_center/account/passwordreset/confirm/`, obj);
    }
    tenatList() {
        return tenantRequest.get(`/tenant_center/tenantList/`);
    }
    userList(data) {
        return tenantRequest.get(`/tenant_center/userList/${data}/`);
    }
    createTenant(data) {
        return tenantRequest.post(`/tenant_center/createTenant/`,data);
    }
    updateSubscription(data) {
        return tenantRequest.post(`/tenant_center/updateSubscription/`,data);
    }
    checkTenantCreateStatus(data) {
        return tenantRequest.post(`/tenant_center/checkTenantCreateStatus/`,data);
    }
    createSuperUser(data) {
        return tenantRequest.post(`/tenant_center/createSuperuser/`,data);
    }
    loadSeedData(data){
        return tenantRequest.post(`/tenant_center/loadSeedData/`,data);
    }
    tenantCostRank(){
        return tenantRequest.get(`/tenant_center/tenantcostrank/`);
    }
    tenantMonthlyCost(){
        return tenantRequest.get(`/tenant_center/tenantmonthlycost/`);
    }
    usageList(tenant, mode, bot, model, knowledge, start, end, page, page_item){
        let params = new URLSearchParams();
        tenant.forEach(t => params.append('tenant', t));
        params.append('mode', mode);
        params.append('bot', bot);
        params.append('model', model);
        params.append('knowledge', knowledge);
        params.append('start', start);
        params.append('end', end);
        params.append('page', page);
        params.append('page_item', page_item);
        return tenantRequest.get(`/tenant_center/aiusagerecord/?${params.toString()}`)
    }
    totalcost(tenant) {
        let params = new URLSearchParams();
        tenant.forEach(t => params.append('tenant', t));
        return tenantRequest.get(`/tenant_center/aitotalusage/?${params.toString()}`);
    }
    chart(tenant, mode, bot, model, knowledge, start, end){
        let params = new URLSearchParams();
        tenant.forEach(t => params.append('tenant', t));
        params.append('mode', mode);
        params.append('bot', bot);
        params.append('model', model);
        params.append('knowledge', knowledge);
        params.append('start', start);
        params.append('end', end);
        return tenantRequest.get(`/tenant_center/aiusagerecord/?${params.toString()}`)
    }
    // ==== 以流程設定租戶 ====
    pipelineCreateTenant(data) {
        return tenantRequest.post(`/tenant_center/createTenant/`, data, NO_TIMEOUT);
    }
    pipelineLoadSeedData(data) {
        return tenantRequest.post(`/tenant_center/loadSeedData/`, data, NO_TIMEOUT);
    }
    pipelineCreateSuperUser(data) {
        return tenantRequest.post(`/tenant_center/createSuperuser/`, data, NO_TIMEOUT);
    }
    pipelineGetStage(schemaName, stage) {
        return tenantRequest.get(`/tenant_center/pipeline/${schemaName}/${stage}/`, NO_TIMEOUT);
    }
    pipelineUpdateStage(schemaName, stage, data) {
        return tenantRequest.post(`/tenant_center/pipeline/${schemaName}/${stage}/`, data, NO_TIMEOUT);
    }
}
export default new TenantCenterService();